<template>

  <div class="video-uploader-container">
    <p class="video-uploader-title">{{ label }}</p>
    <input class="video-uploader-button"
           type="file"
           accept="video/mp4"
           @change="uploadVideo"/>
  </div>

</template>

<script>

export default {
  name: 'VideoUploader',
  props: ['label'],
  data () {
    return {
      video: null
    }
  },
  methods: {
    uploadVideo (e) {
      const file = e.target.files[0]
      if (file.type.indexOf('video/') === -1) {
        console.log('not a video')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.$emit('videoUploaded', event.target.result)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    clear () {
      this.video = null
    }
  }
}

</script>

<style lang="scss" scoped>

  .video-uploader-container {
    margin-bottom: 16px;
  }

  .video-uploader-title {
    font-weight: bold;
    margin-bottom: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/VideoUploader.vue